import React, { useState, useEffect } from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import { translations, fontSizes } from "../translations";

const PlayAudioModal = ({
  showPlayAudioModal,
  handlePlayAudioModalClose,
  siteLanguage,
}) => {
  const [readyButtonText, setReadyButtonText] = useState("");
  const fontSize = fontSizes[siteLanguage] || "1rem";

  useEffect(() => {
    setReadyButtonText(translations[siteLanguage].readyButton);
    console.log(translations[siteLanguage].readyButton);
  }, [siteLanguage]);

  return (
    <Modal
      open={showPlayAudioModal}
      aria-labelledby="play-audio-modal-title"
      aria-describedby="play-audio-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          p: 4,
          bgcolor: "#333",
          color: "white",
          width: "80%",
          "@media (min-width:600px)": {
            width: "40%",
            maxWidth: "500px",
          },
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography
          textAlign="center"
          id="play-audio-modal-description"
          variant="h6"
          component="h2"
          marginBottom={2}
          style={{ fontSize }}
        >
          {readyButtonText}
        </Typography>
        <Button
          sx={{ marginTop: "10px" }}
          onClick={() => handlePlayAudioModalClose()}
          variant="contained"
          color="primary"
          style={{
            textTransform: "capitalize",
            fontSize: "1rem",
            width: "70%",
            alignSelf: "center",
            fontSize,
          }}
        >
          Play
        </Button>
      </Box>
    </Modal>
  );
};

export default PlayAudioModal;
